import { usePageMeta } from '../lib/usePageMeta.js';

export function AboutPage() {
  usePageMeta({
    title: 'About TowShare — Canada\'s peer-to-peer trailer marketplace',
    description:
      'TowShare is a Canadian peer-to-peer trailer rental marketplace built by Waypoint Labs. Operating in Ottawa, Kingston, Perth, Brockville, Carleton Place, and Peterborough.',
    canonicalPath: '/about',
  });
  return (
    <div className="mx-auto max-w-3xl px-4 py-16">
      <h1 className="text-3xl font-bold text-navy mb-4">About TowShare</h1>
      <p className="text-lg text-navy-700 mb-6">
        TowShare is a peer-to-peer marketplace that connects trailer owners with renters
        across Canada. Most utility trailers sit idle 350 days a year. We help owners earn
        on them, and we help renters skip the U-Haul lineup.
      </p>
      <p className="text-navy-700 mb-6">
        Every rental is backed by a refundable damage deposit, Stripe Identity verification,
        and the <a href="/guarantee" className="text-orange hover:underline">$1,500 Trailer Guarantee</a>{' '}
        — TowShare-funded coverage that layers on top of the renter's auto insurance.
      </p>
      <p className="text-navy-700">
        TowShare is built by{' '}
        <a
          href="https://waypointlabz.com"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-navy hover:text-orange"
        >
          Waypoint Labs
        </a>
        , a Canadian product studio building utility marketplaces.
      </p>
    </div>
  );
}
